import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=2f588925&scoped=true&"
import script from "./ViewOrder.vue?vue&type=script&lang=js&"
export * from "./ViewOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=2f588925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f588925",
  null
  
)

export default component.exports